import StatisticsSection from './StatisticsSection';

export default StatisticsSection;
